import { type PropsWithChildren } from 'react'
import { Stack, Typography } from '@mui/material'

type Props = PropsWithChildren<{
  title: string
}>

export default function AccountFilterSection(props: Props) {
  return <Stack
    spacing={2}
    sx={{
      '& + &': {
        borderTop: 1,
        borderColor: 'divider',
        pt: 3,
      },
    }}
  >
    <Typography
      variant="subtitle2"
      component="h4"
      sx={{
        color: 'text.secondary',
        fontWeight: 700,
        textTransform: 'uppercase',
      }}
    >{props.title}</Typography>
    {props.children}
  </Stack>
}
